var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDecimalSubtract = function SvgDecimalSubtract(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 48095620"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.159 12.3163L9.87109 15.6042L13.159 18.8921",
    stroke: "#212121",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.0791 15.6045L9.96289 15.6045",
    stroke: "#212121",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.69187 10.1599C1.45854 10.1599 1.27188 10.0899 1.13188 9.94991C0.991875 9.80058 0.921875 9.61391 0.921875 9.38991C0.921875 9.16591 0.991875 8.98391 1.13188 8.84391C1.27188 8.69458 1.45854 8.61991 1.69187 8.61991C1.92521 8.61991 2.10721 8.69458 2.23788 8.84391C2.37788 8.98391 2.44788 9.16591 2.44788 9.38991C2.44788 9.61391 2.37788 9.80058 2.23788 9.94991C2.10721 10.0899 1.92521 10.1599 1.69187 10.1599Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.94242 10.2299C5.81309 10.2299 4.95442 9.79591 4.36642 8.92791C3.77842 8.05991 3.48442 6.80458 3.48442 5.16191C3.48442 4.06058 3.61509 3.13658 3.87642 2.38991C4.13776 1.63391 4.52509 1.06458 5.03842 0.681911C5.56109 0.299244 6.19576 0.10791 6.94242 0.10791C8.08109 0.10791 8.93976 0.537244 9.51842 1.39591C10.1064 2.24524 10.4004 3.49591 10.4004 5.14791C10.4004 6.24924 10.2698 7.17791 10.0084 7.93391C9.74709 8.68991 9.35976 9.26391 8.84642 9.65591C8.33309 10.0386 7.69842 10.2299 6.94242 10.2299ZM6.94242 9.23591C7.72642 9.23591 8.30509 8.90458 8.67842 8.24191C9.06109 7.56991 9.25242 6.53858 9.25242 5.14791C9.25242 3.74791 9.06109 2.72591 8.67842 2.08191C8.30509 1.42858 7.72642 1.10191 6.94242 1.10191C6.16776 1.10191 5.58909 1.42858 5.20642 2.08191C4.82376 2.73524 4.63242 3.75724 4.63242 5.14791C4.63242 6.53858 4.82376 7.56991 5.20642 8.24191C5.58909 8.90458 6.16776 9.23591 6.94242 9.23591Z",
    fill: "#212121"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDecimalSubtract);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "decimal-subtract.77513ea358a7b98b1c462bba24408973.svg";